module.exports = __webpack_public_path__ + "img/scroll.4e822e08.png";